<script setup lang="ts">
/**
 * The team's mark of the design prototype (`team-ava`): the star in feratel yellow on house blue,
 * 44 pixels square. It stands for the team on the portal overview's team card (B-55) and in the
 * head of the inquiry dialog of portal and website (B-124, A-77); decorative, the text beside it
 * names the team. Both colours are the
 * fixed house colours of `packages/tokens/base.css`, not the theme's brand (UP9, TL 2026-10-19);
 * the star has a contrast of about 4.5 : 1 on the blue. The control radius stands for the
 * prototype's 14 pixels (UP10).
 */
</script>

<template>
  <span
    class="bg-feratel-blue text-feratel-yellow rounded-control flex size-11 flex-none items-center justify-center"
    aria-hidden="true"
    data-team-avatar
  >
    <svg viewBox="0 0 24 24" class="size-5.5">
      <path d="M12 1.5l2.6 7.9 7.9 2.6-7.9 2.6L12 22.5l-2.6-7.9L1.5 12l7.9-2.6z" fill="currentColor" />
    </svg>
  </span>
</template>
